module.exports = __webpack_public_path__ + "img/linkedin.6456d58a.svg";